export default "__VITE_ASSET__D4O$9Jb8__"